import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { FlowsDisplayGridRowDataFragmentGql } from './FlowsDisplayGridRowDataFragmentGql';

export const DatasourceUpstreamFlowsQueryGql: DocumentNode = gql`
query DatasourceUpstreamFlowsQuery($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  publishedDatasources(filter: { vizportalUrlId: $vizportalUrlId }) {
    upstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...FlowsDisplayGridRowDataFragment
      }
    }
  }
}
${FlowsDisplayGridRowDataFragmentGql}
`;
